import templateUrl from './printNavBar.html'

/**
 * print NavBar component to switch between print types and printing pool.
 *
 * @example
 *   <tmr-print-nav-bar
 *     modal-service="someCustomModalService"
 *     show-print-multiple-button="true"
 *     quantity-column="true"
 *     quantity-fix-property="someAppDataProperty"
 *     on-print-clear=""
 *     on-print-remove=""
 *   ></tmr-print-nav-bar>
 *
 * @type {ngComponent}
 * @prop {ngFactory} [modal-service=TmrPrintMultipleModal] Optionally use a non-standar modal by passing its service.
 *   It must be a factory compatible with TmrPrintMultipleModal
 * @prop {boolean=} [show-print-multiple-button=false]
 * @prop {boolean=} [quantity-column=false]
 * @prop {string} [quantity-fix-property] Optionally string to recover enable/disable AppData property
 * @prop {function=} [on-print-clear]
 * @prop {function=} [on-print-remove]
 */
export const tmrPrintNavBar = {
  ngType: 'component',
  controller: 'tmrPrintNavBarController',
  templateUrl,
  bindings: {
    modalService: '<?',
    showPrintMultipleButton: '<?',
    quantityColumn: '<?',
    quantityFixProperty: '<?',
    onPrintClear: '&?',
    onPrintRemove: '&?',
  },
}

/**
 * Controller of component {@link tmrPrintNavBar}.
 *
 * @type {ngController}
 */
export class tmrPrintNavBarController {
  static ngType = 'controller'

  constructor(
    $state,
    $stateParams,
    TmrPrint,
    TmrPrintMultipleModal,
    PrintSession
  ) {
    'ngInject'
    Object.assign(this, {
      $state,
      $stateParams,
      TmrPrint,
      TmrPrintMultipleModal,
      PrintSession,
    })
  }

  $onInit() {
    this.modalService = this.modalService ?? this.TmrPrintMultipleModal
    this.quantityColumn = this.quantityColumn ?? false
    this.currentState = this.$state.current.name
    this.printQueueTitleVariables = { quantity: '...' }
    this.PrintSession.count({
      completed: this.$stateParams.completed ?? 'false',
    }).then(quantity => (this.printQueueTitleVariables.quantity = quantity))
    this.initTabs()
  }

  /** Initializes dynamic print tabs */
  initTabs() {
    this.items = this.TmrPrint.getPrintOperations().map(
      ({ name: state, label }) => ({
        state,
        title:
          state === 'app.operations.print.queue'
            ? 'OPERATIONS.PRINT.QUEUE.TABTITLE'
            : label,
        titleVariables:
          state === 'app.operations.print.queue'
            ? this.printQueueTitleVariables
            : null,
      })
    )
  }

  openDialog($event) {
    return this.modalService($event, {
      clearCallback: () => this.onPrintClear(),
      removeCallback: resourceToRemove =>
        this.onPrintRemove({ resourceToRemove }),
      quantityColumn: this.quantityColumn,
      quantityFixProperty: this.quantityFixProperty,
    })
  }
}
